import { PolygraphyProductUrlType } from '../../../../../../../services/exports/Constants';

export default {
  form: {
    url_type: {
      options: {
        [PolygraphyProductUrlType.OnlineShop]: 'Tienda en línea',
        [PolygraphyProductUrlType.Storefront]: 'Escaparate',
        [PolygraphyProductUrlType.Custom]: 'Personalizado',
      },
    },
  },
  labels: {
    save_changes_to_see_preview: 'Guarda los cambios para ver la vista previa',
  },
  buttons: {
    save_and_preview: 'Guardar y previsualizar',
  },
  toasts: {
    failed_to_load_data: 'Error al cargar el producto',
    failed_to_save_changes: '¡Error al guardar los cambios!',
    changes_got_saved: '¡Cambios guardados!',
  },
};
